<template>
    <div>
        <p v-if="label" :class="{ 'input-label': isMargin, 'input-label-no-margin': !isMargin } ">{{ inputLabel }}</p>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
        },
        isRequired: {
            type: Boolean
        },
        isMargin: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        inputLabel() {
            let name = this.label;
            let requiredSymbol = this.isRequired ? "*" : "";
            return `${name}${requiredSymbol}`;
        },
    }
};
</script>

<style lang="css" scoped>
.input-label-no-margin {
    font-size: 13px;
    line-height: 13px;
    color: var(--description-grey);
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FormLabelTitle.vue